"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfo = void 0;
const getCharge_js_1 = require("../../util/getCharge.js");
const getMF_js_1 = require("../../util/getMF.js");
/**
 *
 * @param {import('openchemlib').Molecule} molecule
 * @param {Map} moleculesInfo
 * @returns
 */
function getInfo(molecule, moleculesInfo) {
    if (moleculesInfo.has(molecule)) {
        return moleculesInfo.get(molecule);
    }
    const reactantInfo = {
        molfile: molecule.toMolfile(),
        idCode: molecule.getIDCode(),
        mf: (0, getMF_js_1.getMF)(molecule).mf,
        em: Math.round(molecule.getMolecularFormula().absoluteWeight * 1e6) / 1e6,
        charge: (0, getCharge_js_1.getCharge)(molecule),
    };
    moleculesInfo.set(molecule, reactantInfo);
    return reactantInfo;
}
exports.getInfo = getInfo;
//# sourceMappingURL=getReactantInfo.js.map